import { useEffect, useState } from "react";
/**
 * Returns which items of a step have an action in progress, and how to run one.
 *
 * @param onBusyChange Callback with whether any action is in progress
 */
export function usePendingIds(onBusyChange) {
  const [pendingIds, setPendingIds] = useState(() => new Set());
  const isBusy = pendingIds.size > 0;
  useEffect(() => {
    onBusyChange(isBusy);
  }, [isBusy, onBusyChange]);
  async function runWhilePending(ids, action) {
    setPendingIds(current => new Set([...current, ...ids]));
    try {
      return await action();
    } finally {
      setPendingIds(current => new Set([...current].filter(id => !ids.includes(id))));
    }
  }
  return {
    pendingIds,
    runWhilePending
  };
}